import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DEFAULT_SIZE_MAX, DEFAULT_SIZE_MIN, DEFAULT_LAYERS, } from "@erikwatson/snowfall";
import { Control } from "../../../control/control";
import { useDispatch } from "react-redux";
import { Range } from "../../../range/range";
import { setSizeMax, setSizeMin, } from "../../../../features/config/config.slice";
import { ControlGroup } from "../../../controlGroup/controlGroup";
import { Group } from "../../../group/group";
export const SnowflakeSize = ({ index, layer }) => {
    const dispatch = useDispatch();
    return (_jsx(_Fragment, { children: _jsx(Group, { colour: "grey-2", name: "Size", children: _jsxs(ControlGroup, { children: [_jsx(Control, { name: "Minimum", tooltip: "The minimum size of the snowflakes", showOutput: true, reset: () => {
                            const min = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].size.min
                                : DEFAULT_SIZE_MIN;
                            dispatch(setSizeMin({
                                index,
                                min,
                            }));
                        }, value: layer.size.min, onChange: (event) => dispatch(setSizeMin({
                            index,
                            min: Number(event.target.value),
                        })), children: _jsx(Range, { min: "0", max: "100", step: "1" }) }), _jsx(Control, { name: "Maximum", tooltip: "The maximum size of the snowflakes", showOutput: true, reset: () => {
                            const max = index < DEFAULT_LAYERS.length
                                ? DEFAULT_LAYERS[index].size.max
                                : DEFAULT_SIZE_MAX;
                            dispatch(setSizeMax({
                                index,
                                max,
                            }));
                        }, value: layer.size.max, onChange: (event) => dispatch(setSizeMax({
                            index,
                            max: Number(event.target.value),
                        })), children: _jsx(Range, { min: "0", max: "100", step: "1" }) })] }) }, index) }));
};
